import $ from 'jquery'
import IMask from 'imask'
import { format } from '../../utils/currency'

class Module {
  constructor ($module, $referralWallet) {
    $referralWallet.trigger('click')

    this.module = $module
    this.profiles = $module.find('#withdrawal_payoutProfile')
    this.amount = $module.find('.js-amount')
    this.total_amount = $module.find('.js-total-amount')

    this.bind()
  }

  bind () {
    const self = this
    let commissionPercent = 0
    let commissionMin = 0
    let exchangeRate = 1
    let currency = null

    const maskedAmount = new IMask(this.amount[0], {
      mask: Number,
      scale: 2,
      signed: false,
      thousandsSeparator: ' ',
      radix: '.',
      mapToRadix: [','],
      normalizeZeros: false
    })

    this.module.submit(function () {
      self.amount.val(self.parseFloat(maskedAmount.unmaskedValue))
    })

    this.profiles.closest('.form-group').find('a').on('click', function (e) {
      e.preventDefault()
      self.profiles.trigger('change')
    })

    this.profiles.on('change', function () {
      const profile = $(this).val()

      commissionPercent = parseFloat($(this).data('profile-' + profile + '-commission-percent'))
      commissionMin = parseFloat($(this).data('profile-' + profile + '-commission-min'))
      exchangeRate = parseFloat($(this).data('profile-' + profile + '-exchange-rate'))
      currency = $(this).data('profile-' + profile + '-currency')

      self.amount.trigger('change')
    }).trigger('change')

    this.amount.on('change blur keyup', function () {
      const amount = self.parseFloat(maskedAmount.unmaskedValue)
      self.total_amount.html(format(self.recalc(amount, exchangeRate, commissionPercent, commissionMin), currency))
    }).trigger('change')
  }

  recalc (amount, exchangeRate, commissionPercent, commissionMin) {
    amount *= exchangeRate

    let commissionAmount = amount / 100 * commissionPercent
    if (commissionMin > commissionAmount) {
      commissionAmount = commissionMin
    }

    return amount - commissionAmount
  }

  parseFloat (amount) {
    return parseFloat(amount.replace(/\s+/g, '').replace(/,/, '.'))
  }
}

$(function () {
  $('.js-referrals-withdrawal').each(function () {
    new Module($(this), $('#referrals'))
  })
})
